/** Centralized caption configuration — shared across Post, Story, and Reel editors */

export const BRAND_VOICES = {
  luxury: {
    id: 'luxury',
    name: 'Luxury',
    description: 'Sophisticated, aspirational, understated elegance',
    color: '#D4AF37',
    icon: 'Crown',
  },
  bold: {
    id: 'bold',
    name: 'Bold',
    description: 'High-energy, punchy, confident declarations',
    color: '#EF4444',
    icon: 'Zap',
  },
  minimalist: {
    id: 'minimalist',
    name: 'Minimalist',
    description: 'Clean, modern, every word earns its place',
    color: '#64748B',
    icon: 'Minus',
  },
};

export const CONTENT_TYPES = {
  post: { id: 'post', name: 'Post', icon: 'Image', maxLength: 2200 },
  story: { id: 'story', name: 'Story', icon: 'Circle', maxLength: 300 },
  reel: { id: 'reel', name: 'Reel', icon: 'Film', maxLength: 2200 },
};

export const REEL_HOOKS = [
  'Wait for it...',
  'This home has EVERYTHING.',
  'POV: Your dream home.',
  "You won't believe this.",
  'Just wait until you see the kitchen.',
  'Stop scrolling. Look at this.',
  'This is the one.',
  'Dream home alert.',
  'Tour time!',
  'Would you live here?',
];

export const CTA_PATTERNS = {
  post: ['Schedule a showing today', 'Link in bio for details', 'DM me for a private tour'],
  story: ['Swipe up', 'DM for info', 'Tap for details'],
  reel: ['DM for info', 'Check the link in bio', 'Comment TOUR for details', 'Save this for later'],
};
